// Empty-state surface — rendered when the API reports `dataAvailable=false`
// (zero snapshots in the trend window). Surfaces the X / 30 days collected
// progress so a brand-new owner can see how close they are to a populated
// trend instead of staring at a flat zero baseline.

import { cn } from "@shared/lib";

import { LIFECYCLE_TREND_STRINGS } from "../lib/strings";

export interface LifecycleTrendEmptyStateProps {
  daysWithData: number;
  totalDays: number;
  className?: string;
}

export function LifecycleTrendEmptyState({
  daysWithData,
  totalDays,
  className,
}: LifecycleTrendEmptyStateProps) {
  return (
    <div
      role="status"
      className={cn(
        "flex flex-col items-center gap-2 rounded-lg border border-dashed bg-background p-6 text-center",
        className,
      )}
    >
      <h3 className="text-sm font-semibold">
        {LIFECYCLE_TREND_STRINGS.empty.title}
      </h3>
      <p className="text-xs text-muted-foreground">
        {LIFECYCLE_TREND_STRINGS.empty.body}
      </p>
      <p className="text-[11px] text-muted-foreground">
        {LIFECYCLE_TREND_STRINGS.empty.progress(daysWithData, totalDays)}
      </p>
    </div>
  );
}
